module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RIVAL TO THE QUEEN.")]), _vm._v(" Copyright © 2010 by Carolly Erickson. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Erickson, Carolly, 1943–")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Rival to the queen / Carolly Erickson. — 1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN 978-0-312-37974-2")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("1. Leicester, Lettice Dudley, Countess of, 1543–1634—Fiction. 2. Elizabeth I, Queen of England, 1533–1603—Fiction. 3. Leicester, Robert Dudley, earl of, 1532?–1588—Fiction. 4. Nobility—Great Britain—Fiction. 5. Queens—Great Britain—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("PS3605.R53R58 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("813'.6—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "right-paraa"
  }, [_vm._v("2010025197")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("First Edition: October 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("10   9   8   7   6   5   4   3   2   1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8422d616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0